function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 2L12 8L6 14",
  stroke: "#0A648F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgChervonRight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChervonRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chervon-right.083eda25.svg";
export { ForwardRef as ReactComponent };